import { render } from "./Footer.ce.vue?vue&type=template&id=36021938"
import script from "./Footer.ce.vue?vue&type=script&lang=js"
export * from "./Footer.ce.vue?vue&type=script&lang=js"

import _style_0 from "@/assets/css/tailwind.css?vue&type=style&index=0&inline&lang=css"
import _style_1 from "@/assets/css/_fontface.css?vue&type=style&index=1&inline&lang=css"
import _style_2 from "@/assets/css/_variables.css?vue&type=style&index=2&inline&lang=css"
import _style_3 from "@/assets/css/_global.css?vue&type=style&index=3&inline&lang=css"
import _style_4 from "@/assets/css/_animations.css?vue&type=style&index=4&inline&lang=css"
import _style_5 from "@/assets/css/main.css?vue&type=style&index=5&inline&lang=css"
import _style_6 from "./Footer.ce.vue?vue&type=style&index=6&id=36021938&inline&lang=css"

import exportComponent from "/home/ubuntu/jenkins/workspace/suiteweb-web-components_gamma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0,_style_1,_style_2,_style_3,_style_4,_style_5,_style_6]]])

export default __exports__